module.exports = __webpack_public_path__ + "img/znjf.ba9c6003.png";